var _a;
import { __decorate, __metadata } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import { Logger } from '@patsnap/tahiti-core/common/logger';
/**
 * Represents a Symbol for the API that supports pagination.
 */
export const ApiPaginated = Symbol('ApiPaginated');
export function createEmptyPaginatedResult(req) {
    return {
        page: req.page || 1,
        pageSize: req.pageSize || 10,
        totalPage: 0,
        total: 0,
        totalWithoutFilter: 0,
        data: [],
    };
}
export const PaginatedEntities = Symbol('PaginatedEntities');
let AbstractPaginatedEntities = class AbstractPaginatedEntities {
    constructor() {
        this._states = this.defaultStates;
        this._onStatesChangeEmitter = new Emitter();
        this.onStatesChange = this._onStatesChangeEmitter.event;
        this._onResultChangeEmitter = new Emitter();
        this.onResultChange = this._onResultChangeEmitter.event;
    }
    get defaultStates() {
        return {
            loading: false,
            error: false,
        };
    }
    getStates() {
        return { ...this._states };
    }
    _changeStates(states) {
        this._states.error = states.error;
        this._states.loading = states.loading;
        this._onStatesChangeEmitter.fire(states);
    }
    _changeResult(result) {
        this._onResultChangeEmitter.fire(result);
    }
    async load(query) {
        this._lastQuery = query;
        this._changeStates({ loading: true, error: false });
        this._changeResult(createEmptyPaginatedResult(query));
        const resp = await this.apiPaginated.query(query).catch((err) => {
            this._logger.error(err);
            this._states.error = true;
            return createEmptyPaginatedResult(query);
        });
        this._states.loading = false;
        this._changeResult(resp);
        this._changeStates({ ...this._states });
        return resp;
    }
    reload() {
        if (!this._lastQuery) {
            return;
        }
        return this.load(this._lastQuery);
    }
};
__decorate([
    inject(Logger),
    __metadata("design:type", typeof (_a = typeof Logger !== "undefined" && Logger) === "function" ? _a : Object)
], AbstractPaginatedEntities.prototype, "_logger", void 0);
AbstractPaginatedEntities = __decorate([
    injectable()
], AbstractPaginatedEntities);
export { AbstractPaginatedEntities };
